import { toast } from "react-toastify";

import { CleanupGaResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const cleanupGa = async () => {
  const resp = await api.post<CleanupGaResponseBodyType>(
    `/v2/integrations/google/ga/cleanup`,
    {}
  );
  return resp.data;
};
export const useCleanupGa = () => {
  return useMutation<CleanupGaResponseBodyType, Error, any, any>({
    mutationFn: async () => cleanupGa(),
    onSuccess: () => {
      toast.success("Google Analytics Cleanup Finished!");
    },
  });
};
